import { useResponsive } from '@ui/style/useResponsive';
const useRelationsStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: isMobileIpadNavigation ? 1 : 4.25,
            overflow: 'hidden',
            height: '100%'
        },
        relationsContainer: {
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1,
            gap: '12px'
        }
    };
};
export default useRelationsStyles;
